import { supabase } from "@/lib/supabase/supabaseClient";
import { AddSurveyWithQuestionsProps, UseAddSurveyWithQuestionsProps } from ".";

export const addSurveyWithQuestions = ({crm_system}: UseAddSurveyWithQuestionsProps) => async (props: AddSurveyWithQuestionsProps) => {
    if(crm_system === undefined) {
        throw new Error("CRM system is required");
    }
    const { questions, ...surveyProps } = props;
    const { data: surveyData, error: surveyError } = await supabase
        .from('survey')
        .insert(surveyProps)
        .select()
        .maybeSingle();
    if (surveyError) {
        console.error(surveyError);
        throw new Error("Error adding survey");
    }
    if (!surveyData) {
        throw new Error("Survey not created");
    }

    const surveyId = surveyData.id;
    const questionsWithFieldTypeContextStack = questions?.map(question => ({
        ...question,
        field_type_context_stack: [
            ...(question?.field_type_context_stack || []),
            { field_type: question.field_type, crm_system },
        ],
    }))
    // Insert questions
    const { data: questionData, error: questionError } = await supabase
        .from('question')
        .insert(questionsWithFieldTypeContextStack?.map(question => ({ ...question, survey_id: surveyId }))|| [])
        .select();

    if (questionError) {
        console.error(questionError);
        throw new Error("Error adding questions");
    }
    const questionsToBeAddedToQuestionBank = questionsWithFieldTypeContextStack?.filter(q => !q.question_bank_ref_id);

    // TODO: Add questions to question bank in one go
    if (questionsToBeAddedToQuestionBank && questionsToBeAddedToQuestionBank.length > 0) {
        const { error: questionBankError } = await supabase
            .from('question_bank')
            .insert(questionsToBeAddedToQuestionBank.map(({question_bank_ref_id, survey_id, ...q}) => ({ ...q, organisation_id: surveyProps.organisation_id })))
            .select();

        if (questionBankError) {
            console.error(questionBankError);
            if( questionBankError.code === '42501' ) {
                console.error("Question bank question already exists");
            }else {
                throw new Error("Error adding questions to question bank");
            }
        }
    }

    return { survey: surveyData, questions: questionData };
}
